import { getData } from '@/utils/axiosUtils';

const getZoomLoginLink = async (companyId, location = window.location.href) => {
    return await getData(
        `/company/${companyId}/zoomLoginLink?domain=${location}`,
    );
};

export default getZoomLoginLink;